import { Component, h, Host, Prop } from '@stencil/core';
import { SearchResultItem } from '~model/search-result-item';
import { Translate } from '~service/translation-service';

@Component({
  tag: 'staedtler-search-result-item-company',
})
export class SearchResultItemCompany {
  @Prop() item: SearchResultItem;

  render() {
    return (
      <Host class={'staedtler-search-result-item'}>
        <div class="search-result-company">
          <h5>{this.item.title}</h5>
          <p>
            <span innerHTML={this.item.content} /> <a href={this.item.url}>{Translate.translate('search.result.readMore')}</a>
          </p>
        </div>
      </Host>
    );
  }
}
